import { httpGet } from 'common/helpers/http'
import { validateKeyTypes } from 'common/helpers/validation'

/// needed for generating declarations
import { ContentAPI } from 'publication-types'
import { isFeatureEnabled } from 'common/feature-togglings/features'
import { DataLoaderGlobalParams } from 'common/data/resources'

export const validate = (value: any): ContentAPI.CurationV4ExpandedResponseDTO => {
    const errors = validateKeyTypes('curation', value, {
        id: 'string',
        title: 'string',
        minimumItems: 'number',
        itemSlots: 'number',
        lastUpdated: 'string',
        metadata: {},
        articles: [{}],
    })

    if (errors) {
        throw new Error('Curation response invalid\n    ' + errors.join('    \n'))
    }

    return value
}

export interface Options {
    profiles?: boolean
    offset?: number
    pageSize?: number
    includePremium?: boolean
}

export const getCuration = (
    services: DataLoaderGlobalParams,
    curationId: string,
    options: Options
) => {
    if (curationId === undefined) {
        throw new Error('getCuration, curationId should not be undefined')
    }

    const include_premium =
        // option defaults to true, which is then confirmed/denied by the feature toggle
        // see commments in https://bitbucket.swmdigital.io/projects/PROD/repos/web/pull-requests/1501/overview
        options.includePremium !== false &&
        isFeatureEnabled(services.store.getState().toggles, 'digital-subscriptions', false)
    const query = {
        profiles: options.profiles,
        from: options.offset !== undefined ? options.offset + 1 : undefined,
        to:
            options.offset !== undefined && options.pageSize
                ? options.offset + options.pageSize
                : undefined,
        include_premium: include_premium || undefined,
    }

    return httpGet({
        log: services.log,
        validate,
        baseUrl: services.config.contentApi,
        path: `v4/curation/${curationId}`,
        query,
        customHeaders: {
            caller: services.config.apiCallerHeader,
        },
    })
}
